import { render, staticRenderFns } from "./ProductFormScreen.vue?vue&type=template&id=1923111a&"
import script from "./ProductFormScreen.vue?vue&type=script&lang=ts&"
export * from "./ProductFormScreen.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports